import { QuestionIcon } from '@phosphor-icons/react'
import classNames from 'classnames'
import { TooltipWithHover } from '../tooltip.tsx'
import * as styles from './scope-hierarchy-hint.css.ts'

/**
 * The help affordance on the Projects page description: a hover card naming the two scopes feedback
 * can be left at, broader first, and saying which one Pixee reads first.
 */
export const ScopeHierarchyHint: React.FC = () => (
  <TooltipWithHover
    // 360px rather than the 300px default so the longest row holds one line.
    maxWidth={360}
    side="bottom"
    align="start"
    sideOffset={3}
    trigger={
      <button type="button" className={styles.trigger} aria-label="How resolution works">
        <QuestionIcon size={16} weight="regular" aria-hidden />
      </button>
    }
  >
    <div className={styles.card}>
      <span className={styles.heading}>Feedback scopes</span>
      <span className={styles.lead}>Pixee considers narrower scopes first.</span>
      {/* A description list, so the scope and its reach are announced as a pair rather than as four
          loose strings. Two rows, written out: an array with an undefined-indent placeholder said
          less than this does. */}
      <dl className={styles.rows}>
        <dt className={styles.rowLevel}>Project</dt>
        <dd className={styles.rowReach}>Applies to only the assigned repositories</dd>
        <dt className={classNames(styles.rowLevel, styles.rowLevelDepth1)}>Repository</dt>
        <dd className={styles.rowReach}>Applies to only that repository</dd>
      </dl>
    </div>
  </TooltipWithHover>
)
